export default __webpack_public_path__ + "static/nparks-4c5df2d4de2252e222e854bdace65220.png";